import { ClaimMessages } from "src/languages/interfaces";

enum EClaimModule {
  ACCESS = "access",
  ACTIVATE_FUTURE_STATUS = "activateFutureStatus",
  ACTIVATE_STATUS = "activateStatus",
  ALTER = "alter",
  CHANGE_STATUS = "changeStatus",
  CHANGE_SUPPLY = "changeSupply",
  COMMERCIAL_DEFAULT = "commercialDefault",
  COST_CHANGE_REMINDER = "costChangeReminder",
  CREATE_COPY = "createCopy",
  DELETE = "delete",
  EXPORT = "export",
  INACTIVATE = "inactivate",
  INACTIVATE_STATUS = "inactivateStatus",
  INCLUDE = "include",
  PRINT = "print",
  TECHNICAL_DATA_CHANGE_REMINDER = "technicalDataChangeReminder",
  ABRAMS_CURVE_CHANGE_REMINDER = "abramsCurveChangeReminder",
  INCLUDE_LOGO = "includeLogo",
  DELETE_LOGO = "deleteLogo",
  DOWNLOAD = "download",
  ALTER_EXTERNAL_ID = "alterExternalId",
  CHANGE_ALLOCATIONS = "changeAllocations",
  DISPATCH = "dispatch",
  REINTEGRATE = "reintegrate",
  CANCEL = "cancel",
  REQUEST_ADJUSTMENT = "requestAdjustment",
  APPROVE_ADJUSTMENT = "approveAdjustment",
  CHANGE_LINK = "changeLink",
  IGNORE_LINK = "ignoreLink",
  CLOSE_INVENTORY = "closeInventory",
  CLOSE_PRODUCTION = "closeProduction",
  REOPEN_PRODUCTION = "reopenProduction",
  REOPEN_INVENTORY = "reopenInventory",
  ALTER_DELIVERY = "alterDelivery",
  ALTER_PUMPING = "alterPumping",
  ALTER_SCHEDULING = "alterScheduling",
  APPROVE_DISAPPROVE_PENDING_REQUESTS = "approveDisapprovePendingRequests",
  CHANGE_DELIVERY_ROUTE = "changeDeliveryRoute",
  DISPATCH_PUMPING_TICKET = "dispatchPumpingTicket",
  WATER_CUT = "waterCut",
  SEND_TO_AUTOMATION = "sendToAutomation",
  CREDIT_LIMIT_WEBSERVICE_RESEND_FOR_ANALYSIS = "creditLimitWebserviceResendForAnalysis",
  ALERTS_PAGE_ACCESS = "alertsPageAccess",
  CLIENT_PREPAID_ALTER = "clientPrepaidAlter",
  CONSTRUCTION_NOT_FOUND_ALTER = "constructionNotFoundAlter",
  CONSTRUCTION_EXPIRED_ALTER = "constructionExpiredAlter",
  SCHEDULING_WITHOUT_EXTERNALID_ALTER = "schedulingWithoutExternalIdAlter",
  SUPPLY_NOT_AUTHORIZED_BY_SECURITY_VISIT_ALTER = "supplyNotAuthorizedBySecurityVisitAlter",
  PRODUCT_WITHOUT_QUOTATION_ALTER = "productWithoutQuotationAlter",
  PRODUCT_OR_RECIPE_INACTIVE_ALTER = "productOrRecipeInactiveAlter",
  CLIENT_DELINQUENT_ALTER = "clientDelinquentAlter",
  CLIENT_EXPIRED_CREDIT_DATE_ALTER = "clientExpiredCreditDateAlter",
  CLIENT_WITHOUT_CREDIT_LIMIT_ALTER = "clientWithoutCreditLimitAlter",
  WAITING_CREDIT_LIMIT_ANALYSIS_ALTER = "waitingCreditLimitAnalysisAlter",
  PLANT_UNAVAILABLE_ALTER = "plantUnavailableAlter",
  CLOSE_SCHEDULING = "closeScheduling",
  REOPEN_SCHEDULING = "reopenScheduling",
  PRODUCT_REQUIRES_APPROVAL = "productRequiresApproval",
  PRODUCT_TYPE_REQUIRES_APPROVAL = "productTypeRequiresApproval",
  PRODUCT_GROUP_REQUIRES_APPROVAL = "productGroupRequiresApproval",
  SUPPLY_GROUP_DEVIATION = "supplyGroupDeviation",
  SUPPLY_DEVIATION = "supplyDeviation",
  WAITING_CREDIT_LIMIT_ANALYSIS = "waitingCreditLimitAnalysis",
  CREDIT_LIMIT_VALIDATION = "creditLimitValidation",
  NOT_SENT_FOR_AUTOMATION = "notSentForAutomation",
  MISSING_AUTOMATION_RESPONSE = "missingAutomationResponse",
  INSUFFICIENT_STOCK = "insufficientStock",
  PRODUCT_GROUP_REUSE_OUT_OF_PARAMS = "productGroupReuseOutOfParams",
  PRODUCT_REUSE_OUT_OF_PARAMS = "productReuseOutOfParams",
  GRAVEL_REUSE_OUT_OF_PARAMS = "gravelReuseOutOfParams",
  PRODUCT_GROUP_NO_LOAD_REUSE_PARAM_SET = "productGroupNoLoadReuseParamSet",
  PRODUCT_NO_LOAD_REUSE_PARAM_SET = "productNoLoadReuseParamSet",
  GRAVEL_NO_LOAD_REUSE_PARAM_SET = "gravelNoLoadReuseParamSet",
  PUMPING_DIVERGENT_VOLUME = "pumpingDivergentVolume",
  PUMPING_WAITING_CREDIT_LIMIT_ANALYSIS = "pumpingWaitingCreditLimitAnalysis",
  PUMPING_CREDIT_LIMIT_VALIDATION = "pumpingCreditLimitValidation",
  PUMPING_EXPIRED_CREDIT_DATE = "pumpingExpiredCreditDate",
  ACTUAL_SLUMP = "actualSlump",
  CONCRETE_MIXER_SCHEDULE = "concreteMixerSchedule",
  WATER_ADDED_IN_CONSTRUCTION = "waterAddedInConstruction",
  ODOMETER = "odometer",
  HOUR_METER = "hourMeter",
  PUMP_SCHEDULE_WITHOUT_DELIVERY_TICKET_PUMP = "pumpScheduleWithoutDeliveryTicketPump",
  PUMP_SCHEDULE_MISSING_M3_TO_ISSUE_DELIVERY = "pumpScheduleMissingM3ToIssueDelivery",
  UNDELIVERED_AND_UNCANCELLED_SCHEDULES = "undeliveredAndUncancelledSchedules",
  UNDELIVERED_AND_UNCANCELLED_DELIVERIES = "undeliveredAndUncancelledDeliveries",
  UNLINKED_WEIGHINGS = "unlinkedWeighings",
  SEFAZ_STATUS_FISCAL_DOCUMENT_NOT_SENT = "sefazStatusFiscalDocumentNotSent",
  SEFAZ_STATUS_FISCAL_DOCUMENT_NO_ANSWER = "sefazStatusFiscalDocumentNoAnswer",
  SEFAZ_STATUS_FISCAL_DOCUMENT_WITH_REJECTION = "sefazStatusFiscalDocumentWithRejection",
  ADDITIONAL_MODIFICATIONS = "additionalModifications",
  LOAD_TICKET_WITHOUT_DELIVERY_TICKET = "loadTicketWithoutDeliveryTicket",
  LOAD_REUSE_WITHOUT_DESTINATION = "loadReuseWithoutDestination",
  MANUAL_ENTRY = "manualEntry",
  VIEW_REPORTS = "viewReports",
  REGISTER_EXECUTION = "registerExecution",
  UPDATE_EXECUTION = "updateExecution",
  DELETE_EXECUTION = "deleteExecution",
  COMPLETE_TASK = "completeTask",
  ADD_NOTES = "addNotes",
  VIEW_PLANT_STATUS = "viewPlantStatus",
  VIEW_PRODUCTION = "viewProduction",
  VIEW_ALARMS = "viewAlarms",
  MANUAL_COMMAND = "manualCommand",
  ADJUST_ORDERS = "adjustOrders",
  ACKNOWLEDGE_ALARM = "acknowledgeAlarm",
  AUTHORIZE_PRIVILEGED = "authorizePrivileged",
  MANAGE_LOCAL_USERS = "manageLocalUsers",
  VIEW_AUDIT = "viewAudit",
  PLANT_DEFINITION = "plantDefinition",
  ALTER_APPLICATION_OF_OWN_LABOR = "alterApplicationOfOwnLabor",
  ADJUSTED_STRENGTH = "adjustedStrength",
  EXCLUDE_RUPTURE_FROM_STATISTICS = "excludeRuptureFromStatistics",
  ALTER_PRODUCT_WEIGHTED = "alterProductWeighted",
}

const claimObject = {
  [EClaimModule.ACCESS]: {
    id: "1",
    title: ClaimMessages.access
  },
  [EClaimModule.ACTIVATE_FUTURE_STATUS]: {
    id: "2",
    title: ClaimMessages.activateFutureStatus
  },
  [EClaimModule.ACTIVATE_STATUS]: {
    id: "3",
    title: ClaimMessages.activateStatus
  },
  [EClaimModule.ALTER]: {
    id: "4",
    title: ClaimMessages.alter
  },
  [EClaimModule.CHANGE_STATUS]: {
    id: "5",
    title: ClaimMessages.changeStatus
  },
  [EClaimModule.CHANGE_SUPPLY]: {
    id: "6",
    title: ClaimMessages.changeSupply
  },
  [EClaimModule.COMMERCIAL_DEFAULT]: {
    id: "7",
    title: ClaimMessages.commercialDefault
  },
  [EClaimModule.COST_CHANGE_REMINDER]: {
    id: "8",
    title: ClaimMessages.costChangeReminder
  },
  [EClaimModule.CREATE_COPY]: {
    id: "9",
    title: ClaimMessages.createCopy
  },
  [EClaimModule.DELETE]: {
    id: "10",
    title: ClaimMessages.delete
  },
  [EClaimModule.EXPORT]: {
    id: "11",
    title: ClaimMessages.export
  },
  [EClaimModule.INACTIVATE]: {
    id: "12",
    title: ClaimMessages.inactivate
  },
  [EClaimModule.INACTIVATE_STATUS]: {
    id: "13",
    title: ClaimMessages.inactivateStatus
  },
  [EClaimModule.INCLUDE]: {
    id: "14",
    title: ClaimMessages.include
  },
  [EClaimModule.PRINT]: {
    id: "15",
    title: ClaimMessages.print
  },
  [EClaimModule.TECHNICAL_DATA_CHANGE_REMINDER]: {
    id: "16",
    title: ClaimMessages.technicalDataChangeReminder
  },
  [EClaimModule.ABRAMS_CURVE_CHANGE_REMINDER]: {
    id: "41",
    title: ClaimMessages.abramsCurveChangeReminder
  },
  [EClaimModule.INCLUDE_LOGO]: {
    id: "17",
    title: ClaimMessages.includeLogo
  },
  [EClaimModule.DELETE_LOGO]: {
    id: "18",
    title: ClaimMessages.deleteLogo
  },
  [EClaimModule.DOWNLOAD]: {
    id: "19",
    title: ClaimMessages.download
  },
  [EClaimModule.ALTER_EXTERNAL_ID]: {
    id: "20",
    title: ClaimMessages.alterExternalId
  },
  [EClaimModule.CHANGE_ALLOCATIONS]: {
    id: "21",
    title: ClaimMessages.changeAllocations
  },
  [EClaimModule.DISPATCH]: {
    id: "22",
    title: ClaimMessages.dispatch
  },
  [EClaimModule.REINTEGRATE]: {
    id: "23",
    title: ClaimMessages.reintegrate
  },
  [EClaimModule.CANCEL]: {
    id: "24",
    title: ClaimMessages.cancel
  },
  [EClaimModule.REQUEST_ADJUSTMENT]: {
    id: "121",
    title: ClaimMessages.requestAdjustment
  },
  [EClaimModule.APPROVE_ADJUSTMENT]: {
    id: "122",
    title: ClaimMessages.approveAdjustment
  },
  [EClaimModule.CHANGE_LINK]: {
    id: "25",
    title: ClaimMessages.changeLink
  },
  [EClaimModule.IGNORE_LINK]: {
    id: "26",
    title: ClaimMessages.ignoreLink
  },
  [EClaimModule.CLOSE_INVENTORY]: {
    id: "27",
    title: ClaimMessages.closeInventory
  },
  [EClaimModule.CLOSE_PRODUCTION]: {
    id: "28",
    title: ClaimMessages.closeProduction
  },
  [EClaimModule.REOPEN_PRODUCTION]: {
    id: "29",
    title: ClaimMessages.reopenProduction
  },
  [EClaimModule.ALTER_DELIVERY]: {
    id: "30",
    title: ClaimMessages.alterDelivery
  },
  [EClaimModule.ALTER_PUMPING]: {
    id: "31",
    title: ClaimMessages.alterPumping
  },
  [EClaimModule.ALTER_SCHEDULING]: {
    id: "32",
    title: ClaimMessages.alterScheduling
  },
  [EClaimModule.APPROVE_DISAPPROVE_PENDING_REQUESTS]: {
    id: "33",
    title: ClaimMessages.approveDisapprovePendingRequests
  },
  [EClaimModule.CHANGE_DELIVERY_ROUTE]: {
    id: "34",
    title: ClaimMessages.changeDeliveryRoute
  },
  [EClaimModule.REOPEN_INVENTORY]: {
    id: "35",
    title: ClaimMessages.reopenInventory
  },
  [EClaimModule.DISPATCH_PUMPING_TICKET]: {
    id: "37",
    title: ClaimMessages.dispatchPumpingTicket
  },
  [EClaimModule.WATER_CUT]: {
    id: "38",
    title: ClaimMessages.waterCut
  },
  [EClaimModule.SEND_TO_AUTOMATION]: {
    id: "39",
    title: ClaimMessages.sendToAutomation
  },
  [EClaimModule.CREDIT_LIMIT_WEBSERVICE_RESEND_FOR_ANALYSIS]: {
    id: "40",
    title: ClaimMessages.creditLimitWebserviceResendForAnalysis
  },
  [EClaimModule.ALERTS_PAGE_ACCESS]: {
    id: "42",
    title: ClaimMessages.alertsPageAccess
  },
  [EClaimModule.CLIENT_PREPAID_ALTER]: {
    id: "43",
    title: ClaimMessages.clientPrepaidAlter
  },
  [EClaimModule.CONSTRUCTION_NOT_FOUND_ALTER]: {
    id: "45",
    title: ClaimMessages.constructionNotFoundAlter
  },
  [EClaimModule.CONSTRUCTION_EXPIRED_ALTER]: {
    id: "47",
    title: ClaimMessages.constructionExpiredAlter
  },
  [EClaimModule.SCHEDULING_WITHOUT_EXTERNALID_ALTER]: {
    id: "49",
    title: ClaimMessages.schedulingWithoutExternalIdAlter
  },
  [EClaimModule.SUPPLY_NOT_AUTHORIZED_BY_SECURITY_VISIT_ALTER]: {
    id: "51",
    title: ClaimMessages.supplyNotAuthorizedBySecurityVisitAlter
  },
  [EClaimModule.PRODUCT_WITHOUT_QUOTATION_ALTER]: {
    id: "53",
    title: ClaimMessages.productWithoutQuotationAlter
  },
  [EClaimModule.PRODUCT_OR_RECIPE_INACTIVE_ALTER]: {
    id: "55",
    title: ClaimMessages.productOrRecipeInactiveAlter
  },
  [EClaimModule.CLIENT_DELINQUENT_ALTER]: {
    id: "57",
    title: ClaimMessages.clientDelinquentAlter
  },
  [EClaimModule.CLIENT_EXPIRED_CREDIT_DATE_ALTER]: {
    id: "59",
    title: ClaimMessages.clientExpiredCreditDateAlter
  },
  [EClaimModule.CLIENT_WITHOUT_CREDIT_LIMIT_ALTER]: {
    id: "61",
    title: ClaimMessages.clientWithoutCreditLimitAlter
  },
  [EClaimModule.WAITING_CREDIT_LIMIT_ANALYSIS_ALTER]: {
    id: "63",
    title: ClaimMessages.waitingCreditLimitAnalysisAlter
  },
  [EClaimModule.PLANT_UNAVAILABLE_ALTER]: {
    id: "65",
    title: ClaimMessages.plantUnavailableAlter
  },
  [EClaimModule.CLOSE_SCHEDULING]: {
    id: "66",
    title: ClaimMessages.closeScheduling
  },
  [EClaimModule.REOPEN_SCHEDULING]: {
    id: "67",
    title: ClaimMessages.reopenScheduling
  },
  [EClaimModule.PRODUCT_REQUIRES_APPROVAL]: {
    id: "68",
    title: ClaimMessages.blockReasonProductRequiresApproval
  },
  [EClaimModule.PRODUCT_TYPE_REQUIRES_APPROVAL]: {
    id: "69",
    title: ClaimMessages.blockReasonProductTypeRequiresApproval
  },
  [EClaimModule.PRODUCT_GROUP_REQUIRES_APPROVAL]: {
    id: "70",
    title: ClaimMessages.blockReasonProductGroupRequiresApproval
  },
  [EClaimModule.SUPPLY_GROUP_DEVIATION]: {
    id: "71",
    title: ClaimMessages.blockReasonSupplyGroupDeviation
  },
  [EClaimModule.SUPPLY_DEVIATION]: {
    id: "72",
    title: ClaimMessages.blockReasonSupplyDeviation
  },
  [EClaimModule.WAITING_CREDIT_LIMIT_ANALYSIS]: {
    id: "73",
    title: ClaimMessages.blockReasonWaitingCreditLimitAnalysis
  },
  [EClaimModule.CREDIT_LIMIT_VALIDATION]: {
    id: "74",
    title: ClaimMessages.blockReasonCreditLimitValidation
  },
  [EClaimModule.NOT_SENT_FOR_AUTOMATION]: {
    id: "75",
    title: ClaimMessages.blockReasonNotSentForAutomation
  },
  [EClaimModule.MISSING_AUTOMATION_RESPONSE]: {
    id: "76",
    title: ClaimMessages.blockReasonMissingAutomationResponse
  },
  [EClaimModule.INSUFFICIENT_STOCK]: {
    id: "77",
    title: ClaimMessages.blockReasonInsufficientStock
  },
  [EClaimModule.PRODUCT_GROUP_REUSE_OUT_OF_PARAMS]: {
    id: "78",
    title: ClaimMessages.blockReasonProductGroupReuseOutOfParams
  },
  [EClaimModule.PRODUCT_REUSE_OUT_OF_PARAMS]: {
    id: "79",
    title: ClaimMessages.blockReasonProductReuseOutOfParams
  },
  [EClaimModule.GRAVEL_REUSE_OUT_OF_PARAMS]: {
    id: "80",
    title: ClaimMessages.blockReasonGravelReuseOutOfParams
  },
  [EClaimModule.PRODUCT_GROUP_NO_LOAD_REUSE_PARAM_SET]: {
    id: "81",
    title: ClaimMessages.blockReasonProductGroupNoLoadReuseParamSet
  },
  [EClaimModule.PRODUCT_NO_LOAD_REUSE_PARAM_SET]: {
    id: "82",
    title: ClaimMessages.blockReasonProductNoLoadReuseParamSet
  },
  [EClaimModule.GRAVEL_NO_LOAD_REUSE_PARAM_SET]: {
    id: "83",
    title: ClaimMessages.blockReasonGravelNoLoadReuseParamSet
  },
  [EClaimModule.PUMPING_DIVERGENT_VOLUME]: {
    id: "84",
    title: ClaimMessages.blockReasonDivergentVolume
  },
  [EClaimModule.PUMPING_WAITING_CREDIT_LIMIT_ANALYSIS]: {
    id: "85",
    title: ClaimMessages.blockReasonWaitingCreditLimitAnalysis
  },
  [EClaimModule.PUMPING_CREDIT_LIMIT_VALIDATION]: {
    id: "86",
    title: ClaimMessages.blockReasonCreditLimitValidation
  },
  [EClaimModule.PUMPING_EXPIRED_CREDIT_DATE]: {
    id: "87",
    title: ClaimMessages.blockReasonExpiredCreditDate
  },
  [EClaimModule.ACTUAL_SLUMP]: {
    id: "88",
    title: ClaimMessages.inconsistencyActualSlump
  },
  [EClaimModule.CONCRETE_MIXER_SCHEDULE]: {
    id: "89",
    title: ClaimMessages.inconsistencyConcreteMixerSchedules
  },
  [EClaimModule.WATER_ADDED_IN_CONSTRUCTION]: {
    id: "90",
    title: ClaimMessages.inconsistencyWaterAddedInConstruction
  },
  [EClaimModule.ODOMETER]: {
    id: "91",
    title: ClaimMessages.inconsistencyOdometer
  },
  [EClaimModule.HOUR_METER]: {
    id: "92",
    title: ClaimMessages.inconsistencyHourMeter
  },
  [EClaimModule.PUMP_SCHEDULE_WITHOUT_DELIVERY_TICKET_PUMP]: {
    id: "93",
    title: ClaimMessages.inconsistencyPumpScheduleWithoutDeliveryTicketPump
  },
  [EClaimModule.PUMP_SCHEDULE_MISSING_M3_TO_ISSUE_DELIVERY]: {
    id: "94",
    title: ClaimMessages.inconsistencyPumpScheduleMissingM3ToIssueDelivery
  },
  [EClaimModule.UNDELIVERED_AND_UNCANCELLED_SCHEDULES]: {
    id: "95",
    title: ClaimMessages.inconsistencyUndeliveredAndUncancelledSchedules
  },
  [EClaimModule.UNDELIVERED_AND_UNCANCELLED_DELIVERIES]: {
    id: "96",
    title: ClaimMessages.inconsistencyUndeliveredAndUncancelledDeliveries
  },
  [EClaimModule.UNLINKED_WEIGHINGS]: {
    id: "97",
    title: ClaimMessages.inconsistencyUnlinkedWeighings
  },
  [EClaimModule.SEFAZ_STATUS_FISCAL_DOCUMENT_NOT_SENT]: {
    id: "98",
    title: ClaimMessages.inconsistencySefazStatusFiscalDocumentNotSend
  },
  [EClaimModule.SEFAZ_STATUS_FISCAL_DOCUMENT_NO_ANSWER]: {
    id: "99",
    title: ClaimMessages.inconsistencySefazStatusFiscalDocumentNoAnswer
  },
  [EClaimModule.SEFAZ_STATUS_FISCAL_DOCUMENT_WITH_REJECTION]: {
    id: "100",
    title: ClaimMessages.inconsistencySefazStatusFiscalDocumentWithRejection
  },
  [EClaimModule.ADDITIONAL_MODIFICATIONS]: {
    id: "101",
    title: ClaimMessages.inconsistencyAdditionalModifications
  },
  [EClaimModule.LOAD_TICKET_WITHOUT_DELIVERY_TICKET]: {
    id: "102",
    title: ClaimMessages.inconsistencyLoadTicketWithoutDeliveryTicket
  },
  [EClaimModule.LOAD_REUSE_WITHOUT_DESTINATION]: {
    id: "103",
    title: ClaimMessages.inconsistencyLoadReuseWithoutDestination
  },
  [EClaimModule.VIEW_REPORTS]: {
    id: "104",
    title: ClaimMessages.viewReports
  },
  [EClaimModule.REGISTER_EXECUTION]: {
    id: "105",
    title: ClaimMessages.registerExecution
  },
  [EClaimModule.UPDATE_EXECUTION]: {
    id: "106",
    title: ClaimMessages.updateExecution
  },
  [EClaimModule.DELETE_EXECUTION]: {
    id: "107",
    title: ClaimMessages.deleteExecution
  },
  [EClaimModule.COMPLETE_TASK]: {
    id: "108",
    title: ClaimMessages.completeTask
  },
  [EClaimModule.ADD_NOTES]: {
    id: "109",
    title: ClaimMessages.addNotes
  },
  [EClaimModule.VIEW_PLANT_STATUS]: {
    id: "110",
    title: ClaimMessages.viewPlantStatus
  },
  [EClaimModule.VIEW_PRODUCTION]: {
    id: "111",
    title: ClaimMessages.viewProduction
  },
  [EClaimModule.VIEW_ALARMS]: {
    id: "112",
    title: ClaimMessages.viewAlarms
  },
  [EClaimModule.MANUAL_COMMAND]: {
    id: "113",
    title: ClaimMessages.manualCommand
  },
  [EClaimModule.ADJUST_ORDERS]: {
    id: "114",
    title: ClaimMessages.adjustOrders
  },
  [EClaimModule.ACKNOWLEDGE_ALARM]: {
    id: "115",
    title: ClaimMessages.acknowledgeAlarm
  },
  [EClaimModule.AUTHORIZE_PRIVILEGED]: {
    id: "116",
    title: ClaimMessages.authorizePrivileged
  },
  [EClaimModule.MANAGE_LOCAL_USERS]: {
    id: "117",
    title: ClaimMessages.manageLocalUsers
  },
  [EClaimModule.VIEW_AUDIT]: {
    id: "118",
    title: ClaimMessages.viewAudit
  },
  [EClaimModule.PLANT_DEFINITION]: {
    id: "119",
    title: ClaimMessages.plantDefinition
  },
  [EClaimModule.MANUAL_ENTRY]: {
    id: "120",
    title: ClaimMessages.manualEntry
  },
  [EClaimModule.ALTER_APPLICATION_OF_OWN_LABOR]: {
    id: "123",
    title: ClaimMessages.alterApplicationOfOwnLabor
  },
  [EClaimModule.ADJUSTED_STRENGTH]: {
    id: "124",
    title: ClaimMessages.adjustedStrength
  },
  [EClaimModule.EXCLUDE_RUPTURE_FROM_STATISTICS]: {
    id: "125",
    title: ClaimMessages.excludeRuptureFromStatistics
  },
  [EClaimModule.ALTER_PRODUCT_WEIGHTED]: {
    id: "126",
    title: ClaimMessages.alterProductWeighted
  }
};

export { EClaimModule, claimObject };
